import httpService from './httpService';

export const getCountries = (data) => {
    return httpService.get("/Countries",data)
            .then((response) => {
               return response && response.data;
            });
}